import { Component, Injector, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'arbitrage-type-form',
    templateUrl: './arbitrage-type-form.component.html',
    styleUrls: ['./arbitrage-type-form.component.scss'],
    standalone: false
})
export class ArbitrageTypeFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = [
    {
      value: 'STOCK',
      label: 'Stock',
      suffix: { title: 'A' },
    },
    {
      value: 'FLUX',
      label: 'Flux',
      suffix: { title: 'B' },
    },
    { value: 'BOTH', label: 'Les deux', suffix: { title: 'C' } },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  getArbitrageTypeOptions(product: FormControl) {
    const monthlyPayment = product?.value?.parameters?.monthlyPayment;
    return !!monthlyPayment ? this.options : this.options.slice(0, 1);
  }

  isArbitrageWithFlux(product: FormControl) {
    return (
      product?.value?.parameters?.arbitrageType &&
      product?.value?.parameters?.arbitrageType !== 'STOCK'
    );
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
